<template>
  <Menu mode="horizontal" theme="light" :active-name="activeName" style="height:40px;line-height:40px;" @on-select="handleMenuSelect">
    <MenuItem :name="menu.fdFrontLink" v-for="menu in menus" :key="menu.fdKey">
      <span slot="title">
        <Icon :type="menu.icon"></Icon>
        {{menu.fdName}}
      </span>
    </MenuItem>
  </Menu>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      activeName: '',
    };
  },
  computed: {
    ...mapGetters(['menus', 'breadcrumb']),
  },
  methods: {
    handleMenuSelect(name) {
      if (name.indexOf('globalprotal') === -1) {
        /* 国内系统跳转到gsc.midea.com */
        const { origin } = window.location;
        window.location.href = `${origin.replace(/(gsc)(hk|-hk|eu|-eu|us|-us)?(.*)/g, '$1$3')}${name}`;
      }
    },
  },
  watch: {
    breadcrumb(val) {
      if (!val.length) {
        this.activeName = window.location.href.indexOf('.html') > -1 ? window.location.pathname : window.location.pathname + 'index.html';
      } else {
        this.activeName = val[0].fdFrontLink;
      }
    },
  },
};
</script>
